// GiaBella Jewels — Theme JS

document.addEventListener('DOMContentLoaded', function () {

  // ── Mobile Menu ──
  const hamburger = document.getElementById('hamburger');
  const mobileNav = document.getElementById('mobileNav');
  if (hamburger && mobileNav) {
    hamburger.addEventListener('click', () => {
      mobileNav.classList.toggle('open');
      document.body.style.overflow = mobileNav.classList.contains('open') ? 'hidden' : '';
    });
  }

  // ── Mobile sub-menus ──
  window.toggleMobileSub = function(btn) {
    const sub = btn.nextElementSibling;
    if (sub) sub.classList.toggle('open');
  };

  // ── Cart Drawer ──
  const cartToggle = document.getElementById('cartToggle');
  const cartClose = document.getElementById('cartClose');
  const cartDrawer = document.getElementById('cartDrawer');
  const cartOverlay = document.getElementById('cartOverlay');

  function openCart() {
    cartDrawer.classList.add('open');
    cartOverlay.classList.add('open');
    document.body.style.overflow = 'hidden';
    refreshCartUI();
  }

  function closeCart() {
    cartDrawer.classList.remove('open');
    cartOverlay.classList.remove('open');
    document.body.style.overflow = '';
  }

  if (cartToggle) cartToggle.addEventListener('click', openCart);
  if (cartClose) cartClose.addEventListener('click', closeCart);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);

  // ── Shopify Cart API ──
  async function addToCart(variantId, quantity = 1) {
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity })
      });
      if (res.ok) {
        await refreshCartUI();
        openCart();
      }
    } catch (e) {
      console.error('Add to cart error:', e);
    }
  }

  async function removeFromCart(key) {
    try {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0 })
      });
      await refreshCartUI();
    } catch (e) {
      console.error('Remove error:', e);
    }
  }

  async function getCart() {
    const res = await fetch('/cart.js');
    return res.json();
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  async function refreshCartUI() {
    try {
      const cart = await getCart();
      const countEl = document.getElementById('cartCount');
      const bodyEl = document.getElementById('cartBody');
      const emptyEl = document.getElementById('cartEmpty');
      const itemsEl = document.getElementById('cartItems');
      const footerEl = document.getElementById('cartFooter');
      const subtotalEl = document.getElementById('cartSubtotal');

      if (countEl) {
        if (cart.item_count > 0) {
          countEl.textContent = cart.item_count;
          countEl.style.display = 'flex';
        } else {
          countEl.style.display = 'none';
        }
      }

      if (cart.item_count === 0) {
        if (emptyEl) emptyEl.style.display = 'flex';
        if (itemsEl) itemsEl.innerHTML = '';
        if (footerEl) footerEl.style.display = 'none';
      } else {
        if (emptyEl) emptyEl.style.display = 'none';
        if (footerEl) footerEl.style.display = 'block';
        if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);

        if (itemsEl) {
          itemsEl.innerHTML = cart.items.map(item => `
            <div class="cart-item-row">
              <img class="cart-item-img" src="${item.image || ''}" alt="${item.title}">
              <div class="cart-item-info">
                <div class="cart-item-name">${item.product_title}</div>
                <div class="cart-item-price">${formatMoney(item.line_price)}</div>
                <div style="font-size:12px;color:var(--text-light);">Qty: ${item.quantity}</div>
                <button class="cart-item-remove" onclick="removeItem('${item.key}')">Remove</button>
              </div>
            </div>
          `).join('');
        }
      }
    } catch (e) {
      console.error('Cart refresh error:', e);
    }
  }

  window.removeItem = async function(key) {
    await removeFromCart(key);
  };

  // ── Add to Cart buttons (collection/product pages) ──
  document.querySelectorAll('.add-btn[data-variant]').forEach(btn => {
    btn.addEventListener('click', async (e) => {
      e.preventDefault();
      const variantId = btn.dataset.variant;
      btn.textContent = 'Adding...';
      btn.disabled = true;
      await addToCart(variantId);
      btn.textContent = 'Added ✓';
      btn.classList.add('added');
      setTimeout(() => {
        btn.textContent = 'Add to Cart';
        btn.classList.remove('added');
        btn.disabled = false;
      }, 2000);
    });
  });

  // ── Product page ATC form ──
  const atcForm = document.getElementById('atcForm');
  if (atcForm) {
    atcForm.addEventListener('submit', async (e) => {
      e.preventDefault();
      const variantId = atcForm.querySelector('[name="id"]').value;
      const qty = parseInt(atcForm.querySelector('[name="quantity"]')?.value || '1');
      const btn = atcForm.querySelector('.atc-btn');
      btn.textContent = 'Adding...';
      btn.disabled = true;
      await addToCart(variantId, qty);
      btn.textContent = 'Added ✓';
      setTimeout(() => {
        btn.textContent = 'Add to Cart';
        btn.disabled = false;
      }, 2000);
    });
  }

  // ── Qty selector ──
  document.querySelectorAll('.qty-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const input = btn.closest('.qty-wrap')?.querySelector('.qty-input');
      if (!input) return;
      let val = parseInt(input.value) || 1;
      if (btn.dataset.action === 'plus') val = Math.min(val + 1, 99);
      if (btn.dataset.action === 'minus') val = Math.max(val - 1, 1);
      input.value = val;
    });
  });

  // ── Product thumbnails ──
  document.querySelectorAll('.product-thumb').forEach(thumb => {
    thumb.addEventListener('click', () => {
      document.querySelectorAll('.product-thumb').forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
      const main = document.getElementById('mainImg');
      if (main && thumb.querySelector('img')) {
        main.src = thumb.querySelector('img').src.replace('_small', '_large');
      }
    });
  });

  // ── FAQ accordion ──
  document.querySelectorAll('.faq-q').forEach(btn => {
    btn.addEventListener('click', () => {
      const item = btn.closest('.faq-item');
      const isOpen = item.classList.contains('open');
      document.querySelectorAll('.faq-item').forEach(i => i.classList.remove('open'));
      if (!isOpen) item.classList.add('open');
    });
  });

  // ── Order Tracking ──
  const trackForm = document.getElementById('trackForm');
  if (trackForm) {
    trackForm.addEventListener('submit', async (e) => {
      e.preventDefault();
      const orderNum = document.getElementById('orderNum').value.trim();
      const email = document.getElementById('trackEmail').value.trim();
      const result = document.getElementById('trackResult');
      const btn = trackForm.querySelector('button[type="submit"]');

      if (!orderNum || !email) return;
      btn.textContent = 'Searching...';
      btn.disabled = true;

      try {
        const res = await fetch(`/account/orders`, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
        result.classList.add('show');
        result.innerHTML = `
          <p style="font-weight:600;margin-bottom:12px;color:var(--text);">Order #${orderNum}</p>
          <div class="tracking-row"><span>Email</span><span>${email}</span></div>
          <div class="tracking-row"><span>Status</span><span><span class="status-pill status-processing">Processing</span></span></div>
          <p style="margin-top:14px;font-size:13px;color:var(--text-light);">For full details, <a href="/account" style="color:var(--pink);text-decoration:underline;">log in to your account</a> or check your confirmation email.</p>
        `;
      } catch {
        result.classList.add('show');
        result.innerHTML = `<p style="color:#dc2626;">Could not find that order. Please <a href="/pages/contact" style="color:var(--pink);">contact us</a> for help.</p>`;
      }

      btn.textContent = 'Track Order';
      btn.disabled = false;
    });
  }

  // ── Sort select ──
  const sortSelect = document.querySelector('.sort-select');
  if (sortSelect) {
    sortSelect.addEventListener('change', () => {
      window.location = sortSelect.value;
    });
  }

  // Initial cart count
  refreshCartUI();
});
